<div
  class="relative bg-cover bg-center text-white flex items-center justify-center bg-[#FFF]"
>
  <div class="w-[100%]">
    <h4
      class="development-title pl-[104px] bg-[#F8F8F8] h-[100px] items-center justify-center pt-[25px]"
    >
      {{ projectName }}
    </h4>
    <div
      class="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-[80px] p-5"
    >
      <div
        class="group"
        (mouseenter)="isHovering1 = true"
        (mouseleave)="isHovering1 = false"
        (click)="navigateToExpression()"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering1
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Expression of Interest</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering2 = true"
        (mouseleave)="isHovering2 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering2
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
            (click)="navigateToPQQ()"
          />

          <p class="folder-title">
            Pre Qualification <br />
            Questionnaire
          </p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering3 = true"
        (mouseleave)="isHovering3 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering3
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            (click)="navigateToRfp()"
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">Request For Proposal</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering4 = true"
        (mouseleave)="isHovering4 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering4
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            (click)="navigateToRfq()"
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">RFQ</p>
        </div>
      </div>

      <div
        class="group"
        (mouseenter)="isHovering5 = true"
        (mouseleave)="isHovering5 = false"
      >
        <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 rounded-[10px] flex justify-center items-center flex-col cursor-pointer"
        >
          <img
            [src]="
              isHovering5
                ? 'assets/images/hover-project-brief&plan.png'
                : 'assets/images/project-brief&plan.png'
            "
            alt=""
            class="w-[120px] h-[120px]"
          />

          <p class="folder-title">
            Vendor Approval <br />
            & Onboarding
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
